// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "pdf-viewer" + "." + "d725b2e7" + ".css";
};